// External modules
import styled from '@emotion/styled';
// @ts-expect-error checkout/react-components
import { TextButton } from '@checkout/react-components';

// Internal modules
import { HEADER_COLOR, PRIMARY_COLOR } from '@/styles';

type ChangeFieldContainerProps = {
  height?: string;
  paddingBottom?: string;
  paddingTop?: string;
  visibility?: string;
};

const ChangeFieldContainer = styled.div<ChangeFieldContainerProps>`
  cursor: pointer;
  font-size: calc(1em * (14 / 16));
  height: ${({ height = 'auto' }) => height};
  padding-bottom: ${({ paddingBottom }) => paddingBottom};
  padding-top: ${({ paddingTop }) => paddingTop};
  visibility: ${({ visibility }) => visibility || 'initial'};

  @media (min-width: 365px) {
    font-size: calc(1em * (15 / 16));
  }
`;

const ChangeFieldValue = styled.label`
  color: ${HEADER_COLOR};
  font-size: inherit;
  font-weight: 600;
  padding-right: 5px;
  position: relative;

  @media (min-width: 365px) {
    font-size: inherit;
  }
`;

const ChangeFieldTextButton = styled(TextButton)`
  font-size: 12px;
  margin-left: 0.05em;
  position: relative;
  text-decoration: none;

  &:focus,
  &:hover {
    color: ${PRIMARY_COLOR};
    text-decoration: underline;
  }
`;

export { ChangeFieldTextButton, ChangeFieldContainer, ChangeFieldValue };
